import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { TableTree } from "components/TableTree/TableTree";
import { useEffect, useState } from "react";

import { Button } from "components/Button/Button";
import { DataGrid } from "components/DataGrid/DataGrid";
import { Search } from "components/Search/Search";
import { SwitchBtn } from "components/SwitchBtn/SwitchBtn";
import { Toast } from "components/ToastShow/ToastAlert";
import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { getPageSize, trans } from "utils/helpers";
import { getSellableItemsList, getSellableItemsTree } from "./api";
import { MessageType } from "types/enum";

interface Prop {
  itemCodeHandeler: (e, bool) => void;
  onHide: () => void;
  warehouseId?: any;
  searchString?: any;
  warehouseDetailId?: any;
  priceListId?: any;
  IsCustomer?: any;
  isFiscal?:any
}

export const ItemsForSell = ({
  itemCodeHandeler,
  onHide,
  priceListId,
  IsCustomer=false,
  warehouseId,
  searchString,
  warehouseDetailId,
  isFiscal=true
}: Prop) => {
  const [data, setData] = useState<any>();
  const [forceUpdate, setForceUpdate] = useState<boolean>(false);
  const [selectedObj, setSelectedObj] = useState<any>();
  const [idCallback, setIdCallback] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<any>("NoDataForPreview");
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pages, setPages] = useState<number>(0);
  const [filterlist, setFilterlist] = useState<any>("");
  const [showMode, setShowMode] = useState<any>(null);
  const [orderBy, setOrderBy] = useState<any>([]);
  const [search, setSearch] = useState(searchString);

  const setselecetrow = (e) => {
    setSelectedObj(e);
  };
  const sendTreeCode = (e, obj = selectedObj) => {
    e?.preventDefault();
    e?.stopPropagation();
    if (obj) {
      itemCodeHandeler(obj, showMode);
    } else {
      // Toast(trans("Msg_SelectRow"), "warning");
      Toast(trans("Msg_SelectRow"), MessageType.warning);

    }
  };

  const searchHandler = (str) => {
    setPageNum(1);
    setSelectedObj(null);
    if (!str) {
      setSearch("");
    } else {
      setSearch(str);
    }
  };

  const handlechangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(e.currentTarget.value);
    getPageSize("ItemsForSell2", e.currentTarget.value);
    getItemTreeForSellAsync(1);
  };

  const handleGoPage = (value) => {
    if (value) {
      if (value < 1 || value > pages) {
      } else setPageNum(+value);
      getItemTreeForSellAsync(+value);
    } else {
    }
  };
  const handleNextPage = () => {
    if (pageNum < pages) {
      setPageNum(pageNum + 1);
      getItemTreeForSellAsync(pageNum + 1);
    }
  };
  const handlePrevPage = () => {
    if (pageNum > 1) {
      setPageNum((pageNum) => {
        return +pageNum - 1;
      });
      getItemTreeForSellAsync(pageNum - 1);
    }
  };

  
  
  async function getItemTreeForSellAsync(PageNum = pageNum) {
    setLoading(false);
    let pageSizeChangedByUser = getPageSize("ItemsForSell2");
    setPageSize(pageSizeChangedByUser);
    try {
      if (!showMode) {
        const respons = await getSellableItemsTree(
          warehouseId == "allWarehouses" ? null : warehouseId,
          warehouseDetailId,
          priceListId,
          isFiscal,
          IsCustomer
        );
        setData(respons.Data);
      } else {
        const respons = await getSellableItemsList(
            warehouseId == "allWarehouses" ? null : warehouseId,
            warehouseDetailId,
            priceListId,
            PageNum,
            pageSizeChangedByUser,
            orderBy.length == 0 ? null : orderBy.join(","),
            search,
            filterlist,
            isFiscal,
            IsCustomer
          );
          setPages(
            respons.Data.TotalRecords > pageSizeChangedByUser
              ? Math.ceil(respons.Data.TotalRecords / pageSizeChangedByUser)
              : 1
          );
          setData(respons.Data);
      }
    } catch (err: any) {
      setMessage(err?.data?.Message);
    }
    setLoading(true);
  }

  useEffect(() => {
    if(showMode!==null){

      setData(null);
      getItemTreeForSellAsync();
    }
  }, [forceUpdate, showMode, search, filterlist, orderBy]);

  useEffect(() => {
    if (idCallback) {
      setIdCallback(null);
    }
  }, [idCallback]);

  return (
    <>
      <div className="row align-items-start justify-content-between">
        <div className="col ">
            <Search
            defultSerach={search}
              onChange={searchHandler}
              autoSearch={true}
              autoFocus={true}
            />
        </div>
        <div className="col h-100 text-start d-flex justify-content-end ">
          <div style={{ maxWidth: "150px", height: "100%" }}>
            <SwitchBtn
              handleModeCard={(e)=>setShowMode(e)}
              setShape="circle"
              firstMode={'AsList'}
              secondMode={'AsTree'}
              treeMode={true}
              parentModalName={'itemsForSell'}
            />
          </div>
        </div>
      </div>

      <div
        style={{  overflowY: "auto", 
          height: "70vh",
           scrollbarWidth: "thin" }}
      >
        <div className="col-lg-12 my-1 btns_form">
          <Button
            value="select"
            btnType="submit"
            onClick={(e) => {
              sendTreeCode(e);
            }}
          />
          <Button
            btnType="cancel"
            value="Cancel"
            onClick={(e) => {
              onHide();
            }}
          />
        </div>
        {loading ? (
          data ? (
            <>
              {showMode ? (
                <div>
                  {data?.Data ? (
                    <DataGrid
                      useChangingNumberPlacement={true}
                      parentName={"ItemsForSell2"}
                      theadData={Object.keys(data.Data[0])}
                      tbodyData={data.Data}
                      minCellWidth={80}
                      DoubleClick={(e) => {
                        sendTreeCode(null, e);
                      }}
                      selectedRowObjectCallback={setselecetrow}
                      totalRecords={data.TotalRecords}
                      pageNum={pageNum}
                      orderFormat={setOrderBy}
                      orderFormatList={orderBy}
                      handlefiltering={(str) => {
                        setFilterlist(str);
                      }}
                      filterStr={filterlist}
                      pageSize={pageSize}
                      HandleNextPage={handleNextPage}
                      HandlePrevPage={handlePrevPage}
                      handlechangePageSize={handlechangePageSize}
                      first={() => {
                        getItemTreeForSellAsync(pages);
                        setPageNum(pages);
                      }}
                      end={() => {
                        getItemTreeForSellAsync(1);
                        setPageNum(1);
                      }}
                      handleGoPage={handleGoPage}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div>
                  {data && data?.length > 0 && (
                    <TableTree
                      baseUrl={INVENTORYANDSALES_URL}
                      selectedRowObjectCallback={setselecetrow}
                      selectedRowObject={idCallback}
                      DoubleClick={(e) => {
                        sendTreeCode(null, e);
                      }}
                      getChildrenUrl={
                        IsCustomer?ENDPOINTSINVENTORYANDSALES.Sales.CustomersStoreApi.CustomersStore.SellableItemsTree
     :ENDPOINTSINVENTORYANDSALES.Inventory.ItemPriceApis[isFiscal?'ItemsTree':'SellableItemsTree']
                        
                      }
                      theadData={[
                        "Id",
                        "ParentId",
                        "Children",
                        "Description",
                        "Code",
                      ]}
                      startIndex={2}
                      defultparams={{
                        warehouseId:warehouseId,
                        priceListId,
                        warehouseDetailId
                      }}
                      Titleparams={"Description"}
                      Childrenparams={"Children"}
                      defultShow={false}
                      Data={data}
                      parentName={"ItemsForSell"}
                    />
                  )}
                </div>
              )}
            </>
          ) : (
            <Message message={message} type={"error"} />
          )
        ) : (
          <Loading />
        )}
      </div>
    </>
  );
};
